import { ProductPageShowcase } from 'src/modules/products/components/ProductPage/ProductPageShowcase';
import { ProductDTO } from 'src/models/pim';
import { ProductPageHowItWorks } from 'src/modules/products/components/ProductPage/ProductPageHowItWorks';
import { ProductPageCrossSell } from 'src/modules/products/components/ProductPage/ProductPageCrossSell';
import { ProductPageBenefitsSection } from 'src/modules/products/components/ProductPage/ProductPageBenefitsSection';
import { ProductAttributeCode } from 'src/models/pim/attributes';
import { DictionaryTitlesCode } from 'src/models/pim/dictionaries';
import { ProductPageShowcaseAttribute } from 'src/modules/products/components/ProductPage/ProductPageShowcase/ProductPageShowcaseAttribute';
import { useProductAttributes } from 'src/modules/products/hooks/useProductAttributes';
import { useTranslateItem } from 'src/hooks/directus/useTranslateItem';
import { ProductPageLegalMentions } from 'src/modules/products/components/ProductPage/ProductPageLegalMentions';
import { ProductPageResultsSection } from 'src/modules/products/components/ProductPage/ProductPageResultsSection';
import { ProductPageTechnicalFeatures } from 'src/modules/products/components/ProductPage/ProductPageTechnicalFeatures';
import { ProductPageDownloads } from 'src/modules/products/components/ProductPage/ProductPageDownloads';
import { ProductPageSctSection } from 'src/modules/products/components/ProductPage/ProductPageSctSection';
import { ProductPageSEO } from 'src/modules/products/components/ProductPage/ProductPageSEO';

export const ProductPageDevicesTemplate = (product: ProductDTO) => {
  const translateFn = useTranslateItem();

  const { getProductAttribute } = useProductAttributes(product.attributes);

  return (
    <>
      <ProductPageSEO {...product} />

      <ProductPageShowcase product={product}>
        {getProductAttribute(ProductAttributeCode.TreatmentEssentials)
          ?.map(translateFn)
          .map((attr, index) => (
            <ProductPageShowcaseAttribute
              key={attr.value + index}
              product={product}
              label={attr.value}
            />
          ))}
      </ProductPageShowcase>

      <ProductPageBenefitsSection
        product={product}
        textCode={ProductAttributeCode.KeyBenefitsText}
        titleCode={ProductAttributeCode.KeyBenefitsTitle}
        dictionaryTitleCode={DictionaryTitlesCode.KeyBenefits}
      />

      <ProductPageHowItWorks {...product} />

      <ProductPageResultsSection
        product={product}
        dictionaryTitleCode={DictionaryTitlesCode.Results}
        textCode={ProductAttributeCode.ResultsText}
      />

      <ProductPageTechnicalFeatures {...product} />
      <ProductPageDownloads {...product} />
      <ProductPageSctSection {...product} />
      <ProductPageCrossSell {...product} />
      <ProductPageLegalMentions {...product} />
    </>
  );
};
